import logoFull from "@/assets/logo.png";
import { Link } from "react-router";

export function AuthHeader() {
  return (
    <header className="relative z-20 flex h-16 shrink-0 items-center border-b bg-white px-5 sm:h-[72px] sm:px-[clamp(24px,4.5vw,72px)]">
      <Link to="/login">
        <img
          src={logoFull}
          alt="Researchly"
          className="block h-8 w-auto object-contain sm:h-9"
        />
      </Link>
    </header>
  );
}
